/* __next_internal_client_entry_do_not_use__ menu,default auto */ import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import ExpandMore from "@mui/icons-material/ChevronRightOutlined";
import ExpandLess from "@mui/icons-material/ExpandLess";
import { SvgIcon, Typography } from "__barrel_optimize__?names=SvgIcon,Typography!=!@mui/material";
import Collapse from "@mui/material/Collapse";
import List from "@mui/material/List";
import ListItemButton from "@mui/material/ListItemButton";
import Link from "next/link";
import { useState } from "react";
import FunctionsIcon from "../../../../assets/icons/FunctionsIcon";
import PricesIcon from "../../../../assets/icons/PricesIcon";
import SupportIcon from "../../../../assets/icons/SupportIcon";
import { useParams, usePathname } from "next/navigation";
import { useTranslation } from "../../../i18n/client";
function LoginIcon(param) {
    let { color } = param;
    const fill = color || "#000";
    return /*#__PURE__*/ _jsxs(SvgIcon, {
        viewBox: "0 0 20 20",
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M10.2687 10.0916C7.76263 10.0916 5.7229 8.05182 5.7229 5.54578C5.7229 3.03974 7.76263 1 10.2687 1C12.7747 1 14.8145 3.03974 14.8145 5.54578C14.8145 8.05182 12.7774 10.0916 10.2687 10.0916ZM10.2687 2.08804C8.36256 2.08804 6.81367 3.63966 6.81367 5.54305C6.81367 7.44644 8.36528 8.99806 10.2687 8.99806C12.1748 8.99806 13.7237 7.44644 13.7237 5.54305C13.7237 3.63966 12.1748 2.08804 10.2687 2.08804Z",
                fill: fill
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M5.78627 9.70427C6.50345 9.49157 7.28881 9.69609 7.83692 10.2387C8.48865 10.885 9.35309 11.2423 10.2721 11.2423C11.1556 11.2423 11.9955 10.9096 12.639 10.3015C13.228 9.7479 14.0734 9.57065 14.7878 9.85425C16.8603 10.6723 18.1992 12.6439 18.1992 14.8718V15.8998C18.1992 17.6969 16.7376 19.1585 14.9405 19.1585H5.1918C3.39476 19.1585 1.93313 17.6969 1.93313 15.8998V14.8718C1.9304 12.5021 3.51748 10.3778 5.78627 9.70427ZM3.02118 15.8998C3.02118 17.0942 3.99469 18.0677 5.18908 18.0677H14.9378C16.1322 18.0677 17.1057 17.0942 17.1057 15.8998V14.8718C17.1057 13.0938 16.0368 11.5231 14.3843 10.8687C14.2861 10.8305 14.1797 10.8114 14.0734 10.8114C13.8307 10.8114 13.5798 10.9123 13.3835 11.095C12.5381 11.8913 11.431 12.3303 10.2693 12.3303C9.06131 12.3303 7.92418 11.8613 7.06793 11.0105C6.80341 10.7487 6.43255 10.6478 6.09714 10.746C4.28647 11.2832 3.0239 12.9793 3.0239 14.8691V15.8998H3.02118Z",
                fill: fill
            })
        ]
    });
}
function SignUpIcon(param) {
    let { color } = param;
    const fill = color || "#000";
    return /*#__PURE__*/ _jsxs(SvgIcon, {
        viewBox: "0 0 20 20",
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M8.2 9.5C6.17 9.5 4.52 7.85 4.52 5.82C4.52 3.79 6.17 2.14 8.2 2.14C10.23 2.14 11.88 3.79 11.88 5.82C11.88 7.85 10.23 9.5 8.2 9.5ZM8.2 3.34C6.83 3.34 5.72 4.45 5.72 5.82C5.72 7.19 6.83 8.3 8.2 8.3C9.57 8.3 10.68 7.19 10.68 5.82C10.68 4.45 9.57 3.34 8.2 3.34Z",
                fill: fill
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M8.2 10.44C5.2 10.44 2.76 12.88 2.76 15.88V16.6H3.96V15.88C3.96 13.54 5.86 11.64 8.2 11.64C10.54 11.64 12.44 13.54 12.44 15.88V16.6H13.64V15.88C13.64 12.88 11.2 10.44 8.2 10.44Z",
                fill: fill
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M15.2 4.28C15.53 4.28 15.8 4.55 15.8 4.88V6.34H17.26C17.59 6.34 17.86 6.61 17.86 6.94C17.86 7.27 17.59 7.54 17.26 7.54H15.8V9C15.8 9.33 15.53 9.6 15.2 9.6C14.87 9.6 14.6 9.33 14.6 9V7.54H13.14C12.81 7.54 12.54 7.27 12.54 6.94C12.54 6.61 12.81 6.34 13.14 6.34H14.6V4.88C14.6 4.55 14.87 4.28 15.2 4.28Z",
                fill: fill
            })
        ]
    });
}
export const menu = [
    {
        name: "pricing",
        link: "/pricing",
        icon: (param)=>{
            let { color } = param;
            return /*#__PURE__*/ _jsx(PricesIcon, {
                color: color
            });
        }
    },
    {
        name: "functions",
        link: "/functions",
        icon: (param)=>{
            let { color } = param;
            return /*#__PURE__*/ _jsx(FunctionsIcon, {
                color: color
            });
        },
        onlyMobile: true
    },
    {
        name: "support",
        link: "/support",
        icon: (param)=>{
            let { color } = param;
            return /*#__PURE__*/ _jsx(SupportIcon, {
                color: color
            });
        }
    },
    {
        name: "login",
        link: "/api/auth/login",
        icon: (param)=>{
            let { color } = param;
            return /*#__PURE__*/ _jsx(LoginIcon, {
                color: color
            });
        },
        onlyMobile: true
    },
    {
        name: "signUp",
        link: "/signup",
        icon: (param)=>{
            let { color } = param;
            return /*#__PURE__*/ _jsx(SignUpIcon, {
                color: color
            });
        },
        onlyMobile: true
    }
];
const linkStyle = {
    ":hover": {
        background: "none"
    },
    "& p": {
        fontSize: "18px",
        fontWeight: "500",
        color: "#515151",
        textDecoration: "none"
    }
};
const sublinkStyle = {
    paddingLeft: 5,
    ":hover": {
        background: "none"
    },
    "& p": {
        fontSize: "16px",
        fontWeight: "500",
        color: "#868686",
        textDecoration: "none"
    }
};
const activeLink = {
    color: "#FF9F24 !important",
    fontWeight: "700"
};
export default function SideMenu() {
    const params = useParams();
    const path = usePathname();
    const isFunctions = path && path.includes("/functions");
    const [open, setOpen] = useState(isFunctions);
    const { t } = useTranslation(params ? params.lng : "en", "landing-sidebar");
    const handleClick = ()=>{
        setOpen(!open);
    };
    return /*#__PURE__*/ _jsxs(List, {
        sx: {
            width: "100%",
            maxWidth: 360,
            zIndex: 1
        },
        component: "nav",
        "aria-labelledby": "side-menu",
        children: [
            /*#__PURE__*/ _jsxs(ListItemButton, {
                sx: linkStyle,
                onClick: handleClick,
                children: [
                    /*#__PURE__*/ _jsx(Link, {
                        style: {
                            color: "inherit",
                            textDecoration: "inherit"
                        },
                        href: "/functions",
                        children: /*#__PURE__*/ _jsx(Typography, {
                            sx: {
                                paddingRight: 1,
                                ...isFunctions && activeLink
                            },
                            children: t("functions")
                        })
                    }),
                    open ? /*#__PURE__*/ _jsx(ExpandLess, {}) : /*#__PURE__*/ _jsx(ExpandMore, {})
                ]
            }),
            /*#__PURE__*/ _jsx(Collapse, {
                in: open || undefined,
                timeout: "auto",
                unmountOnExit: true,
                children: /*#__PURE__*/ _jsxs(List, {
                    component: "div",
                    disablePadding: true,
                    children: [
                        /*#__PURE__*/ _jsx(ListItemButton, {
                            sx: sublinkStyle,
                            children: /*#__PURE__*/ _jsx(Link, {
                                style: {
                                    color: "inherit",
                                    textDecoration: "inherit"
                                },
                                href: isFunctions ? "#create-invoice" : "/functions#create-invoice",
                                scroll: false,
                                children: /*#__PURE__*/ _jsx(Typography, {
                                    children: t("creatingInvoices")
                                })
                            })
                        }),
                        /*#__PURE__*/ _jsx(ListItemButton, {
                            sx: sublinkStyle,
                            children: /*#__PURE__*/ _jsx(Link, {
                                style: {
                                    color: "inherit",
                                    textDecoration: "inherit"
                                },
                                href: isFunctions ? "#manage-customers" : "/functions#manage-customers",
                                scroll: false,
                                children: /*#__PURE__*/ _jsx(Typography, {
                                    children: t("manageCustomers")
                                })
                            })
                        })
                    ]
                })
            }),
            menu.filter((it)=>!it.onlyMobile).map((it)=>/*#__PURE__*/ _jsx(ListItemButton, {
                    sx: linkStyle,
                    children: /*#__PURE__*/ _jsx(Link, {
                        style: {
                            color: "inherit",
                            textDecoration: "inherit"
                        },
                        href: it.link,
                        children: /*#__PURE__*/ _jsx(Typography, {
                            sx: {
                                ...path && path.includes(it.link) && activeLink
                            },
                            children: t(it.name)
                        })
                    })
                }, it.name))
        ]
    });
}
